import React from "react";
import { Container, Row } from "react-bootstrap";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import TimesheetStructureForm from 'presentation/pages/timesheet-structures/elements/form';

import {
  mountItems
} from 'presentation/pages/timesheet-structures/functions/timesheet-structure-items';


class TimesheetStructureAdd extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      form: {},
      rawDaysOfWeek: [1, 2, 3, 4, 5],
      timesheetStructureItems: [],
      totalItems: 1,
      actionLoading: false,
      error: false,
      message: '',
      data: [],
    };
  }

  componentDidMount() {
    mountItems(this);
  }

  goTo = (destination) => {
    const { history } = this.props;

    history.push(destination);
  };

  render() {
    let { loading, error, message, actionLoading, form } = this.state;
    return (
      <div>
        {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
        {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
        {loading === false && (
          <Container>
            <Row>
              <TimesheetStructureForm
                loading={loading}
                form={form}
                component={this}
              />
            </Row>
          </Container>
        )
        }
      </div>
    );
  };
}

export default TimesheetStructureAdd;
